import { connectTaskWS } from './socket';

// Текущая задача, к которой подключён WebSocket (для живого лога и прогресса)
let currentWsTaskId = null;
// Задача, для которой показываем ссылки на скачивание после завершения
let lastCompletedTaskId = null;
let pollTimer = null;

const totalEmailsSpan = document.getElementById('total-emails');
const checkedEmailsSpan = document.getElementById('checked-emails');
const validEmailsSpan = document.getElementById('valid-emails');
const invalidEmailsSpan = document.getElementById('invalid-emails');
const validLink = document.getElementById('download-valid-link');
const invalidLink = document.getElementById('download-invalid-link');
const queuePanel = document.getElementById('queue-panel');

const POLL_INTERVAL_MS = 2500;

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname === '/') {
    initPage();
  }
});

function initPage() {
  toggleCheckboxes(false);
  toggleStats(false);
  toggleLinks(false);
  refreshQueue();
  pollTimer = setInterval(refreshQueue, POLL_INTERVAL_MS);
  window.addEventListener('beforeunload', () => pollTimer && clearInterval(pollTimer));
}

// ---- Загрузка данных очереди с сервера и обновление UI ----
export function refreshQueue() {
  fetch('/api/queue_status/')
    .then(res => res.json())
    .then(data => {
      if (!data.success) return;
      renderState(data);
    })
    .catch(err => console.error('Ошибка получения очереди:', err));
}

function renderState(data) {
  const current = data.current;
  const queue = data.queue || [];
  const pending = data.pending || [];

  // Статистика показывает текущую выполняемую задачу
  if (current) {
    totalEmailsSpan.textContent = current.total_emails;
    checkedEmailsSpan.textContent = current.checked_emails;
    validEmailsSpan.textContent = current.valid_emails;
    invalidEmailsSpan.textContent = current.invalid_emails;
    document.getElementById('unknown-emails').textContent = current.unknown_emails || 0;
    updateSpeedInfo(current);
    toggleStats(true);

    // Подключаем WS к текущей задаче (только при смене id)
    if (currentWsTaskId !== current.task_id) {
      currentWsTaskId = current.task_id;
      connectTaskWS(current.task_id);
    }
  } else {
    currentWsTaskId = null;
    updateSpeedInfo({});
  }

  // Чекбоксы активны, когда есть что запускать (загруженные файлы)
  toggleCheckboxes(pending.length > 0);
  if (pending.length > 0) setupCheckboxLogic();

  renderQueuePanel(current, queue, pending);
}

function renderQueuePanel(current, queue, pending) {
  let html = '';

  // Выполняется сейчас
  if (current) {
    const pct = current.total_emails
      ? Math.round((current.checked_emails / current.total_emails) * 100) : 0;
    // Остановка уже запрошена — показываем нейтральный статус вместо кнопки,
    // чтобы пользователь не жал «Остановить» повторно, пока хвост очереди не добьётся.
    const stopControl = current.cancel_requested
      ? `<span class="ml-3 shrink-0 flex items-center text-gray-400 text-xs px-3 py-2">Задача останавливается...</span>`
      : `<button data-stop="${current.task_id}"
          class="ml-3 shrink-0 flex items-center text-white bg-gradient-to-r from-red-500 to-red-600 hover:bg-gradient-to-l font-medium rounded-lg text-xs px-3 py-2">
          Остановить
        </button>`;
    html += `
      <div>
        <p class="font-medium text-base mb-2 text-gray-700 dark:text-gray-200">Выполняется</p>
        <div class="flex items-center justify-between rounded-lg bg-white dark:bg-gray-800 px-3 py-2">
          <div class="min-w-0">
            <p class="truncate text-gray-800 dark:text-gray-100">${escapeHtml(current.file_name)}</p>
            <p class="text-xs">${current.checked_emails} / ${current.total_emails} (${pct}%)</p>
          </div>
          ${stopControl}
        </div>
      </div>`;
  }

  // В очереди
  if (queue.length) {
    html += `
      <div>
        <p class="font-medium text-base mb-2 text-gray-700 dark:text-gray-200">В очереди (${queue.length})</p>
        <div class="space-y-1">
          ${queue.map(t => `
            <div class="flex items-center justify-between rounded-lg bg-white dark:bg-gray-800 px-3 py-2">
              <div class="min-w-0">
                <p class="truncate text-gray-800 dark:text-gray-100">
                  <span class="text-gray-400 mr-1">${t.position}.</span>${escapeHtml(t.file_name)}
                </p>
                <p class="text-xs">${t.total_emails} адресов</p>
              </div>
              <button data-remove="${t.task_id}"
                class="ml-3 shrink-0 text-red-500 hover:text-red-600 text-xs">Убрать</button>
            </div>`).join('')}
        </div>
      </div>`;
  }

  // Загруженные, ещё не запущенные
  if (pending.length) {
    html += `
      <div>
        <p class="font-medium text-base mb-2 text-gray-700 dark:text-gray-200">Загруженные файлы (${pending.length})</p>
        <div class="space-y-1">
          ${pending.map(t => `
            <div class="flex items-center justify-between rounded-lg bg-white dark:bg-gray-800 px-3 py-2">
              <div class="min-w-0">
                <p class="truncate text-gray-800 dark:text-gray-100">${escapeHtml(t.file_name)}</p>
                <p class="text-xs">${t.total_emails} адресов</p>
              </div>
              <button data-delete="${t.task_id}"
                class="ml-3 shrink-0 text-red-500 hover:text-red-600 text-xs">Удалить</button>
            </div>`).join('')}
        </div>
        <button id="start-validation"
          class="mt-3 flex items-center text-white bg-gradient-to-r from-green-500 to-green-600 hover:bg-gradient-to-l font-medium rounded-lg text-sm px-5 py-2.5">
          Начать проверку (${pending.length})
        </button>
      </div>`;
  }

  if (html) {
    queuePanel.innerHTML = html;
    queuePanel.classList.remove('hidden');
    bindQueueActions(pending);
  } else {
    queuePanel.innerHTML = '';
    queuePanel.classList.add('hidden');
  }
}

function bindQueueActions(pending) {
  const startBtn = document.getElementById('start-validation');
  if (startBtn) {
    startBtn.addEventListener('click', () => {
      const checks = Array.from(document.querySelectorAll('.check-option:checked')).map(cb => cb.value);
      const ids = pending.map(t => t.task_id);
      startCheck(ids, checks);
    });
  }

  queuePanel.querySelectorAll('[data-stop]').forEach(btn => {
    btn.addEventListener('click', () => stopTask(btn.getAttribute('data-stop'), btn));
  });
  queuePanel.querySelectorAll('[data-remove]').forEach(btn => {
    btn.addEventListener('click', () => stopTask(btn.getAttribute('data-remove')));
  });
  queuePanel.querySelectorAll('[data-delete]').forEach(btn => {
    btn.addEventListener('click', () => deleteTask(btn.getAttribute('data-delete')));
  });
}

// ---- Действия ----

function startCheck(taskIds, selectedChecks) {
  fetch('/api/start_validation/', {
    method: 'POST',
    body: JSON.stringify({ task_ids: taskIds, checks: selectedChecks }),
    headers: { 'Content-Type': 'application/json', 'X-CSRFToken': getCookie('csrftoken') }
  })
    .then(r => r.json())
    .then(data => {
      if (!data.success) alert(`Ошибка: ${data.error}`);
      refreshQueue();
    })
    .catch(e => alert(`Ошибка при запуске: ${e.message}`));
}

// btnEl — необязательная кнопка «Остановить» текущей задачи: сразу после
// подтверждения блокируем её, чтобы пользователь не жал повторно, пока
// хвост уже отправленных в Celery адресов не добьётся (кооперативная отмена).
function stopTask(taskId, btnEl) {
  if (!taskId) return;
  if (!confirm('Остановить проверку этого файла?')) return;

  if (btnEl) {
    btnEl.disabled = true;
    btnEl.textContent = 'Задача останавливается...';
    btnEl.classList.add('opacity-60', 'cursor-not-allowed');
  }

  fetch('/api/stop_validation/', {
    method: 'POST',
    body: JSON.stringify({ task_id: taskId }),
    headers: { 'Content-Type': 'application/json', 'X-CSRFToken': getCookie('csrftoken') }
  })
    .then(r => r.json())
    .then(data => {
      if (!data.success) alert(`Ошибка: ${data.error}`);
      refreshQueue();
    })
    .catch(() => alert('Ошибка при остановке.'));
}

function deleteTask(taskId) {
  if (!taskId) return;
  if (!confirm('Удалить файл из списка?')) return;
  fetch('/api/delete_task/', {
    method: 'POST',
    body: new URLSearchParams({ task_id: taskId }),
    headers: {
      'X-CSRFToken': getCookie('csrftoken'),
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
    .then(r => r.json())
    .then(data => {
      if (!data.success) alert(`Ошибка: ${data.error}`);
      refreshQueue();
    })
    .catch(() => alert('Ошибка при удалении.'));
}

function handleFileUpload(event) {
  const files = Array.from(event.target.files);
  if (!files.length) return;

  showSpinner();
  const formData = new FormData();
  files.forEach(file => formData.append('file', file));

  fetch('/api/upload/', {
    method: 'POST',
    body: formData,
    headers: { 'X-CSRFToken': getCookie('csrftoken') }
  })
    .then(async response => {
      const text = await response.text();
      try { return JSON.parse(text); }
      catch (e) { throw new Error('Ошибка при обработке ответа сервера:\n' + text); }
    })
    .then(data => {
      hideSpinner();
      if (data.success) {
        if (data.errors && data.errors.length) {
          alert(`Часть файлов не загружена:\n${data.errors.join('\n')}`);
        }
        refreshQueue();
      } else {
        alert(`Ошибка: ${data.error}`);
      }
    })
    .catch(error => { hideSpinner(); alert(error.message); });
}

// ---- Скорость / ETA ----
export function updateSpeedInfo(data) {
  const speedRow = document.getElementById('speed-row');
  const speedEl = document.getElementById('check-speed');
  const etaEl = document.getElementById('check-eta');
  if (!speedRow || !speedEl || !etaEl) return;

  if (data.speed) {
    speedEl.textContent = data.speed;
    etaEl.textContent = formatEta(data.eta_seconds);
    speedRow.classList.remove('hidden');
  } else {
    speedRow.classList.add('hidden');
  }
}

// Вызывается из socket.js при завершении задачи по WebSocket
export function onTaskFinished(taskId, status) {
  if (status === 'completed') {
    lastCompletedTaskId = taskId;
    showDownloadLinks(taskId);
  }
  refreshQueue();
}

function formatEta(seconds) {
  if (seconds === null || seconds === undefined) return '—';
  if (seconds < 60) return `${seconds} сек`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} мин ${seconds % 60} сек`;
  const hours = Math.floor(minutes / 60);
  return `${hours} ч ${minutes % 60} мин`;
}

function showDownloadLinks(taskId) {
  toggleLinks(true);
  if (validLink) validLink.href = `/api/download_result/?task_id=${taskId}&type=valid`;
  if (invalidLink) invalidLink.href = `/api/download_result/?task_id=${taskId}&type=invalid`;
  setupDownloadLinks(taskId);
}

// ---- Вспомогательные ----

function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str == null ? '' : String(str);
  return div.innerHTML;
}

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie) {
    document.cookie.split(';').forEach(cookie => {
      cookie = cookie.trim();
      if (cookie.startsWith(name + '=')) {
        cookieValue = decodeURIComponent(cookie.slice(name.length + 1));
      }
    });
  }
  return cookieValue;
}

function showSpinner() {
  const btn = document.getElementById('upload-btn');
  const sp = document.getElementById('loading-spinner');
  if (btn) btn.classList.add('hidden');
  if (sp) sp.classList.remove('hidden');
}

function hideSpinner() {
  const btn = document.getElementById('upload-btn');
  const sp = document.getElementById('loading-spinner');
  if (btn) btn.classList.remove('hidden');
  if (sp) sp.classList.add('hidden');
}

function toggleCheckboxes(enabled) {
  const checkboxes = document.querySelectorAll('#checkbox-group input[type="checkbox"]');
  checkboxes.forEach(cb => { cb.disabled = !enabled; });
  const checkboxGroup = document.getElementById('checkbox-group');
  if (checkboxGroup) {
    checkboxGroup.classList.toggle('opacity-50', !enabled);
    checkboxGroup.classList.toggle('opacity-100', enabled);
  }
}

function toggleStats(enabled) {
  const statsBlock = document.getElementById('stats-block');
  if (statsBlock) {
    statsBlock.classList.toggle('opacity-50', !enabled);
    statsBlock.classList.toggle('opacity-100', enabled);
  }
}

function toggleLinks(isVisible) {
  ['valid', 'invalid', 'unknown'].forEach(type => {
    const link = document.getElementById(`download-${type}-link`);
    if (link) link.classList.toggle('hidden', !isVisible);
  });
}

function setupDownloadLinks(taskId) {
  const links = [
    { id: 'download-valid-link', loadingId: 'valid-loading', type: 'valid' },
    { id: 'download-invalid-link', loadingId: 'invalid-loading', type: 'invalid' },
    { id: 'download-unknown-link', loadingId: 'unknown-loading', type: 'unknown' },
  ];

  links.forEach(({ id, loadingId, type }) => {
    const oldLinkEl = document.getElementById(id);
    const loadingEl = document.getElementById(loadingId);
    if (!oldLinkEl || !loadingEl) return;

    const newLinkEl = oldLinkEl.cloneNode(true);
    newLinkEl.href = `/api/download_result/?task_id=${taskId}&type=${type}`;
    oldLinkEl.parentNode.replaceChild(newLinkEl, oldLinkEl);

    newLinkEl.addEventListener('click', async (e) => {
      e.preventDefault();
      newLinkEl.classList.add('hidden');
      loadingEl.classList.remove('hidden');
      try {
        const response = await fetch(`/api/download_result/?task_id=${taskId}&type=${type}`);
        if (!response.ok) throw new Error('Ошибка при загрузке файла');
        const encodedFileName = response.headers.get("X-Filename");
        const decodedFileName = decodeURIComponent(encodedFileName);
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const tempLink = document.createElement('a');
        tempLink.href = url;
        tempLink.download = decodedFileName;
        tempLink.style.display = 'none';
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        URL.revokeObjectURL(url);
      } catch (error) {
        alert(error.message);
      } finally {
        loadingEl.classList.add('hidden');
        newLinkEl.classList.remove('hidden');
      }
    });
  });
}

function setupCheckboxLogic() {
  const checkAll = document.getElementById('check-all');
  if (!checkAll || checkAll.dataset.bound) return;
  checkAll.dataset.bound = '1';

  const options = document.querySelectorAll('.check-option');
  const syntaxCheck = Array.from(options).find(opt => opt.value === 'syntax');

  checkAll.addEventListener('change', () => {
    options.forEach(opt => { if (opt !== syntaxCheck) opt.checked = checkAll.checked; });
  });
  options.forEach(opt => {
    opt.addEventListener('change', () => {
      const filtered = Array.from(options).filter(o => o !== syntaxCheck);
      checkAll.checked = filtered.every(o => o.checked);
    });
  });
}

// Кнопка загрузки — привязка (элемент есть в шаблоне)
const uploadBtn = document.getElementById('upload-btn');
const fileInput = document.getElementById('file-input');
if (uploadBtn && fileInput) {
  uploadBtn.addEventListener('click', () => fileInput.click());
  fileInput.addEventListener('change', handleFileUpload);
}
